import template from './delegatedCardListMobile.html';
import controller from './delegatedCardListMobile.controller.js';
import './delegatedCardListMobile.scss';

let delegatedCardListMobileComponent = {
  restrict: 'E',
  bindings: {
    employees: '<',
    isMobileApp: '<',
    updateDataEmployees: '&',
  },
  template,
  controller,
};

export default delegatedCardListMobileComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardListMobile.component.js